import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useGetOrderedProductsQuery } from "../store/apiSlice";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { setEmployer } from '../store/postsSlice';
import EditEmployerProfile1 from "./EditEmployerProfile1";

function EmployersCenter(props) {
  const { id } = useParams();
  const employer = useSelector((state) => state.posts.employer);
  //alert(employer.employer_id)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [employerID, setEmployerID] = useState(employer?.employer_id || 7)
  const region = useSelector((state) => state.posts.region);
  const userInfo = useSelector((state) => state.auth.userInfo);
  // const { data, isLoading, isSuccess } = useGetOrderedProductsQuery({ id: userInfo.id });
  let content, content1;

  const { register, handleSubmit, setValue, watch, formState: { errors }, setError } = useForm()
  useEffect(() => {
    register("employer_name", { required: false });
  }, [register]);
  let { expired } = useParams();
  const onEditorStateChange1 = (company_name, id, Region, country) => {
    console.log("============222222=========================", company_name, id, Region, country)
    setEmployerID(id)
    dispatch(setEmployer({ company_name, employer_id: id }))
    //setValue("description", editorState);
  };
  const onSelectUniSearch = (company_name, id, Region, country) => {
    console.log("============33333=========================", company_name, id, Region, country)
    setEmployerID(id)
    dispatch(setEmployer({ company_name, employer_id: id }))

    navigate(`/employers-center/${id}/`);
    //setValue("description", editorState);
  };

  return (
    <div className="w-full flex  flex-col px-6  gap-8 mt-2">

      <div className="w-full flex justify-between">
        <div className="w-full">
          <EditEmployerProfile1 id={employer?.employer_id} />
        </div>

      </div>
    </div>
  );
}
export default EmployersCenter;
